/**
 * @voltxampere/engine — Independent current source AC stamp (Sprint 20)
 *
 * Current-source AC injection mirrors the voltage-source pattern but
 * lands on the terminal nodes directly (no augmented row, like DC).
 * Optional `acMagnitude` + `acPhase` fields encode the phasor:
 *
 *     I_phasor = A · exp(j · phase_rad)
 *
 *  Sign convention: positive I_phasor flows OUT of `pos` (matches
 *  the DC stamp's "arrow points the way current flows" reading).
 *
 *  rhs[pos] += +A·cos(φ) + j·A·sin(φ)
 *  rhs[neg] -=  A·cos(φ) + j·A·sin(φ)
 *
 *  When the AC fields are absent, the source contributes nothing to
 *  the AC system (DC-only current source is open at AC).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { getTerminalNetId } from "../terminal-utils.js";
const DEG_TO_RAD = Math.PI / 180;
export const currentSourceACStamp = (ctx, component) => {
    const params = component.params;
    const acMagnitude = readNumber(params, "acMagnitude");
    if (acMagnitude === undefined || acMagnitude === 0) {
        return;
    }
    const acPhaseDeg = readNumber(params, "acPhase") ?? 0;
    const phaseRad = acPhaseDeg * DEG_TO_RAD;
    const re = acMagnitude * Math.cos(phaseRad);
    const im = acMagnitude * Math.sin(phaseRad);
    const pos = ctx.nodeIndex(getTerminalNetId(component, "pos"));
    const neg = ctx.nodeIndex(getTerminalNetId(component, "neg"));
    ctx.addRhs(pos, re, im);
    ctx.addRhs(neg, -re, -im);
};
function readNumber(params, key) {
    const v = params[key];
    return typeof v === "number" && Number.isFinite(v) ? v : undefined;
}
//# sourceMappingURL=current-source.js.map